/**
 * NIÑOZ — ninoz-performance.js
 * Lazy loading, accordion, scroll reveal, CLS preventie.
 * Geen dependencies. Geen jQuery. Vanilla JS.
 * defer src="{{ 'ninoz-performance.js' | asset_url }}"
 */

(function () {
  'use strict';

  /* ── ACCORDION ──────────────────────────────────────────────── */
  function initAccordions() {
    const accordions = document.querySelectorAll('.ninoz-accordion');

    accordions.forEach(function (accordion) {
      const trigger = accordion.querySelector('.ninoz-accordion__trigger');
      if (!trigger) return;

      accordion.addEventListener('toggle', function () {
        trigger.setAttribute('aria-expanded', accordion.open ? 'true' : 'false');
      });

      /* Sluit andere open accordeons in dezelfde groep */
      accordion.addEventListener('toggle', function () {
        if (!accordion.open) return;
        const group = accordion.getAttribute('name');
        if (!group) return;
        document.querySelectorAll(`details[name="${group}"]`).forEach(function (other) {
          if (other !== accordion && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────────────────────────── */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    const targets = document.querySelectorAll([
      '.ninoz-gender__item',
      '.ninoz-product-card',
      '.ninoz-brands__item',
      '.ninoz-reviews__card',
      '.ninoz-essentials__content',
      '.ninoz-essentials__media'
    ].join(','));

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ninoz--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    targets.forEach(function (el) {
      el.classList.add('ninoz--will-animate');
      observer.observe(el);
    });
  }

  /* ── LAZY IMAGES FALLBACK (voor browsers zonder native lazy) ── */
  function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return; /* native support */

    if (!('IntersectionObserver' in window)) return;

    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    const imageObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.classList.remove('ninoz-lazy');
          imageObserver.unobserve(img);
        });
      },
      { rootMargin: '200px 0px' }
    );

    lazyImages.forEach(function (img) {
      imageObserver.observe(img);
    });
  }

  /* ── SKU VARIANTEN UPDATE ────────────────────────────────────── */
  function initVariantSKU() {
    const skuEl = document.getElementById('ninoz-sku');
    if (!skuEl) return;

    document.addEventListener('variant:changed', function (event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      skuEl.textContent = variant.sku || '—';
    });

    /* Prestige emit ook 'change' op variant select/radios */
    const variantInputs = document.querySelectorAll('[name="id"]');
    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const option = this.options ? this.options[this.selectedIndex] : null;
        if (option && option.dataset.sku) {
          skuEl.textContent = option.dataset.sku;
        }
      });
    });
  }

  /* ── TRUST BAR STICKY (optioneel, lichte hint voor mobiel) ──── */
  function initStickyTrustBar() {
    const trustBar = document.querySelector('.ninoz-trust-bar');
    if (!trustBar) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener('scroll', function () {
      lastScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(function () {
          /* Verberg trust bar pas na 400px scroll op mobiel */
          if (window.innerWidth < 750) {
            trustBar.style.display = lastScrollY > 400 ? 'none' : '';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── CLS PREVENTIE: reserveer ruimte voor afbeeldingen ──────── */
  function preventImageCLS() {
    /* Afbeeldingen zonder width/height attribuut krijgen aspect-ratio */
    const images = document.querySelectorAll('.ninoz-gender__img, .ninoz-product-card__img, .ninoz-essentials__img');
    images.forEach(function (img) {
      if (!img.hasAttribute('width') && !img.hasAttribute('height')) {
        img.style.aspectRatio = img.closest('.ninoz-gender__img-wrap') ? '3/4' : '3/4';
      }
    });
  }

  /* ── INIT ────────────────────────────────────────────────────── */
  function init() {
    initAccordions();
    initScrollReveal();
    initLazyImages();
    initVariantSKU();
    preventImageCLS();
    /* initStickyTrustBar(); — activeer indien gewenst */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
